import React from "react";

const Benefit = ({ title, children }) => (
  <section className="growthlab-benefit">
    <h3>
      <span className="growthlab-check" aria-hidden="true">
        ✓
      </span>
      {title}
    </h3>
    {children}
  </section>
);

const LeftContent = () => {
  return (
    <div className="col-lg-6 col-sm-12 content-left">
      <div className="content-left-wrapper growthlab-panel">
        <div id="social">
          <ul>
            <li>
              <a
                href="https://www.instagram.com/upbirkapp/"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram de Upbirk"
              >
                <i className="icon-instagram" />
              </a>
            </li>
            <li>
              <a
                href="https://twitter.com/Upbirkapp"
                target="_blank"
                rel="noreferrer"
                aria-label="X de Upbirk"
              >
                <i className="icon-twitter" />
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/company/upbirk/"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn de Upbirk"
              >
                <i className="icon-linkedin" />
              </a>
            </li>
          </ul>
        </div>

        <div className="growthlab-brand">
          <a href="https://www.upbirk.com" target="_blank" rel="noreferrer">
            <img src="img/Upbirk_blanco.png" alt="Upbirk" width="180" />
          </a>
        </div>

        <article className="growthlab-content">
          <header className="growthlab-header">
            <div className="growthlab-meta">
              <p className="growthlab-eyebrow">Convocatoria 2026</p>
              <span className="growthlab-extension">
                Inscripciones extendidas
              </span>
            </div>
            <h1>
              Encuesta de Registro <span aria-hidden="true">|</span> UPBIRK
              Growth Lab 2026
            </h1>
            <p>
              Este demo se basa en las bases oficiales de validación tecnológica
              de Upbirk, las cuales son de carácter público y obligatorio para
              todos los participantes. Puedes acceder al documento PDF aquí:{" "}
              <a
                href="https://drive.google.com/file/d/1s_HNTBs4NxGHB3VGNLmsk6rcHobUUspo/view"
                className="growthlab-legal-link"
                target="_blank"
                rel="noreferrer"
                aria-label="Abrir las bases legales en una pestaña nueva"
              >
                Bases legales.pdf
              </a>
              .
            </p>
          </header>

          <h2>¿Qué vas a recibir si eres seleccionado?</h2>

          <Benefit title="Acceso a Project Builder Premium de Upbirk por 30 días">
            <ul>
              <li>Plataforma completa para estructurar tu idea de negocio</li>
              <li>Integración con IA de Upbirk para acelerar tu trabajo</li>
              <li>Chat limitado a 20 mensajes por día para consultas</li>
              <li>Análisis automático de tu proyecto</li>
              <li>Descarga de resultados en PDF</li>
            </ul>
          </Benefit>

          <Benefit title="Demo GrowthLab2026 (diseñado para iniciadores)">
            <p>5 frameworks que estructuran tu idea desde cero:</p>
            <ul>
              <li>
                <b>Lean Canvas:</b> define tu modelo de negocio
              </li>
              <li>
                <b>Buyer Persona:</b> entiende a tu cliente ideal
              </li>
              <li>
                <b>Root Cause Analysis (5 Why):</b> identifica problemas raíz
              </li>
              <li>
                <b>Misión y Visión:</b> define tu dirección estratégica
              </li>
              <li>
                <b>SWOT:</b> analiza tu competencia y oportunidades
              </li>
            </ul>
            <p className="growthlab-deadline">
              Tienes hasta el <b>24 de septiembre de 2026</b> para completar el
              100%.
            </p>
          </Benefit>

          <Benefit title="Oportunidad de ganar incentivos económicos">
            <p>
              Si completas el 100% del programa antes del 24 de septiembre y
              respondes las encuestas ex-ante y ex-post, entrarás en el sorteo.
            </p>
          </Benefit>

          <section className="growthlab-section">
            <h2>Premios disponibles</h2>
            <ul className="growthlab-prizes">
              <li>
                <b>$100.000 CLP</b> + 6 meses de suscripción Premium de Upbirk
                (X1)
              </li>
              <li>
                <b>$50.000 CLP</b> + 6 meses de suscripción Premium de Upbirk
                (X2)
              </li>
              <li>
                Mentoría de Doctor en Innovación + 6 meses de suscripción Premium
                de Upbirk (X5)
              </li>
              <li>6 meses de suscripción Premium de Upbirk (X8)</li>
            </ul>
          </section>

          <section className="growthlab-section growthlab-process">
            <h2>¿Cómo funciona?</h2>
            <ol>
              <li>El registro cierra el 30 de agosto de 2026.</li>
              <li>Entregaremos acceso a todos los inscritos el 31 de agosto.</li>
              <li>
                Tendrás acceso a Project Builder Premium de Upbirk por 30 días.
              </li>
              <li>Antes de empezar, completarás la encuesta ex-ante.</li>
              <li>
                Completarás los 5 frameworks y los enviarás mediante la plataforma
                antes del 24 de septiembre de 2026.
              </li>
              <li>Al terminar el 100%, completarás la encuesta ex-post.</li>
              <li>Verificaremos que cumplas con los requisitos exigidos.</li>
              <li>
                Anunciaremos los resultados y ganadores el 22 de octubre de 2026.
              </li>
            </ol>
          </section>
        </article>
      </div>
    </div>
  );
};

export default LeftContent;
